import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { CustomFormsModule } from 'ng2-validation';
import { Ng2PaginationModule } from 'ng2-pagination';

import { SharedModule } from '../shared/shared.module';

import { UserModalComponent, UsersComponent, UserService, UserTypeSelectionComponent } from './';

@NgModule({
    imports: [CommonModule, SharedModule, Ng2PaginationModule, ReactiveFormsModule, CustomFormsModule],
    declarations: [UserModalComponent, UsersComponent, UserTypeSelectionComponent],
    providers: [UserService]
})
export class UsersModule { }


// WEBPACK FOOTER //
// ./src/app/users/users.module.ts